import { $t } from '@/i18n';
export async function publishFetch(url, options = {}) {
    const { method = 'POST', body, headers = {}, timeout = 60000 } = options;
    const ctrl = new AbortController();
    const timer = setTimeout(() => ctrl.abort(), timeout);
    let resp;
    try {
        resp = await fetch(url, {
            method,
            mode: 'cors',
            credentials: 'omit',
            headers: { 'Content-Type': 'application/json', ...headers },
            body: body == null ? undefined : (typeof body === 'string' ? body : JSON.stringify(body)),
            signal: ctrl.signal,
        });
    }
    catch (e) {
        clearTimeout(timer);
        if (e?.name === 'AbortError')
            throw new Error($t('k_830425e9', { arg_0: timeout, arg_1: url }));
        throw new Error($t('k_7f065035', { arg_0: e?.message || e }));
    }
    clearTimeout(timer);
    // 解析响应 JSON（容错：空响应 / 非 JSON 走 text）
    const text = await resp.text();
    let data = null;
    try {
        data = text ? JSON.parse(text) : null;
    }
    catch {
        data = text;
    }
    if (!resp.ok) {
        const detail = data && typeof data === 'object' && data.error
            ? data.error
            : typeof data === 'string'
                ? data
                : `HTTP ${resp.status}`;
        const err = new Error($t('k_b82cea97', { arg_0: resp.status, arg_1: detail }));
        err.status = resp.status;
        err.body = data;
        throw err;
    }
    return data;
}
